export const PROJECT_TYPE_ID_RESEARCH = 1;
export const PROJECT_TYPE_ID_EXPERTISE = 2;
export const PROJECT_TYPE_ID_PARTNERSHIP = 3;
export const PROJECT_TYPE_ID_EDUCATION = 4;
export const PROJECT_TYPE_ID_RESOURCES = 5;
export const PROJECT_TYPE_ID_EVENT = 6;
export const PROJECT_TYPE_ID_PRODUCT = 7;
export const PROJECT_TYPE_ID_STARTUP = 8;
